import React from 'react';
import { connect } from 'react-redux';

class ContributionsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [],
      openHistory: false,
    };
  }
  render() {
    const { contributionsForm } = this.props;
    return (
      <iframe
        class="airtable-embed"
        src={`https://airtable.com/embed/${contributionsForm}?backgroundColor=grayLight&viewControls=on`}
        frameborder="0"
        onmousewheel=""
        width="100%"
        height="100%"
        // style="background: transparent; border: 1px solid #ccc;"
      ></iframe>
    );
  }
}

const mapStateToProps = (state) => ({
  contributionsForm: state.place.airtable.contributionsForm,
});

export default connect(mapStateToProps)(ContributionsForm);
